import { StateCookie } from '../cookie/cookie';
import { Project } from '../API';
import { Team } from 'src/API';

export const getSelectedTeam = (teams: Team[], teamId?: string | null): Team | undefined => {
  console.log('🎯 HELPER: getSelectedTeam called', {
    teamId,
    teamsCount: teams?.length || 0,
    teams: teams?.map((t) => ({ id: t?.id, name: t?.name })) || [],
  });

  if (!teamId) {
    teamId = new StateCookie().getLastTeamId();
    console.log('🍪 HELPER: Got teamId from cookie:', teamId);
  }

  const lastTeam = teams.filter((f) => !!f).find((t) => t!.id === teamId);

  if (lastTeam) {
    console.log('✅ HELPER: Found team by ID:', { id: lastTeam.id, name: lastTeam.name });
    return lastTeam;
  } else if (teams.length > 0) {
    console.log('⚠️ HELPER: Team not found by ID, using first team:', { id: teams[0]?.id, name: teams[0]?.name });
    return teams[0];
  }

  console.log('❌ HELPER: No team found, returning undefined');
};

export const getInitialProjectFromTeams = (teams: Team[]): Project | undefined | null => {
  const selectedTeam = getSelectedTeam(teams);
  return selectedTeam?.projects?.items ? selectedTeam.projects?.items[0] : undefined;
};

export const getProjectInTeam = (team: Team, projectId: string): Project | undefined | null => {
  return team?.projects?.items?.find((p) => p!.id === projectId);
};
